import { useTranslate } from "src/i18n";

export const useProductPriceSourceTranslate = () => {
  const { t } = useTranslate();

  return {
    poizon: t("product_page.poizon", "Poizon"),
    dewu: t("product_page.dewu", "Dewu"),
    goat: t("product_page.goat", "GOAT"),
    title_price: t("product_page.title_price", "Узнать цену товара"),
    update_price: t("product_page.update_price", "Обновить цены"),
    select_platform_hint: t(
      "product_page.select_platform_hint",
      "Нажмите на платформу, чтобы загрузить цену",
    ),
  };
};
